<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable width="700">
      <v-card :disabled="btnLoading" :loading="btnLoading">

        <v-card-title>
          {{ titleDialog }}
          <v-spacer />
          <v-icon @click="close" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-8">
          <v-text-field
              v-model="form.api_key"
              label="API KEY (Client ID)"
              outlined
              dense
              :error-messages="errors.api_key"
          />
          <v-text-field
              v-model="form.secret_key"
              label="Secret Key (Signature)"
              outlined
              dense
              :error-messages="errors.secret_key"
          />
          <v-text-field
              v-model="form.access_token"
              label="Access Token"
              outlined
              dense
              :error-messages="errors.access_token"
          />
          <v-text-field
              v-model="form.account_id"
              label="Account ID"
              outlined
              dense
              :error-messages="errors.account_id"
          />
          <v-text-field
              v-model="form.service_id"
              label="Service ID"
              outlined
              dense
              :error-messages="errors.service_id"
          />
          <v-text-field
              hide-details="auto"
              v-model="form.store_id"
              label="Store ID"
              outlined
              dense
              :error-messages="errors.store_id"
          />
          <v-switch
              v-model="form.use_partner_request_id"
              label="Utiliser le Request ID du partenaire"
              color="success"
          />

          <v-switch
              v-model="form.is_active"
              label="Activé"
              color="success"
          />
        </v-card-text>

        <v-divider />

        <!-- Actions -->
        <v-card-actions>
          <v-spacer />
          <v-btn
              :loading="btnLoading"
              color="primary"
              depressed
              @click="save"
          >
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HTTP } from "@/http-common";

export default {
  name: "ApiKeyDialog",
  data() {
    return {
      dialog: false,
      titleDialog: "",
      btnLoading: false,
      form: {},
      errors: {},
    };
  },
  methods: {
    open(item = null) {
      this.titleDialog = item ? "Modifier une clé API" : "Ajouter une clé API";
      this.dialog = true;
      this.errors = {};
      this.form = {
        id: item?.id ?? null,
        name: item?.name ?? "",
        account_id: item?.account_id ?? null,
        api_key: item?.api_key ?? "",
        secret_key: item?.secret_key ?? "",
        access_token: item?.access_token ?? "",
        service_id: item?.service_id ?? null,
        store_id: item?.store_id ?? "",
        use_partner_request_id: item?.use_partner_request_id ?? true,
        is_active: item?.is_active ?? true,
      };
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.errors = {};
      const url = this.form.id ? "/v1/api-keys/update" : "/v1/api-keys/store";
      this.btnLoading = true;

      HTTP.post(url, this.form)
          .then(() => {
            this.btnLoading = false;
            this.$successMessage = "Cette API a été enregistrée avec succès.";
            this.close();
            this.$emit("refresh");
          })
          .catch((err) => {
            this.btnLoading = false;
            this.errors = err.response?.data?.errors || {};
            this.$errorMessage = "Une erreur s'est produite, veuillez corriger.";
            console.error(err);
          });
    },
  },
};
</script>
